import { render, staticRenderFns } from "./MobileConfirmation.vue?vue&type=template&id=2a4a7111&scoped=true&"
import script from "./MobileConfirmation.vue?vue&type=script&lang=js&"
export * from "./MobileConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MobileConfirmation.vue?vue&type=style&index=0&id=2a4a7111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a7111",
  null
  
)

export default component.exports